import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class MessageService {
    messages: string[] = [];

    add(message: any, context?: string) {
        //this.messages.push(message);
    }

    clear() {
        this.messages = [];
    }

    constructor() {}
}
